import LegalLayout, { LegalSection } from "@/components/LegalLayout";

const AvisoLegal = () => (
  <LegalLayout title="Aviso Legal">
    <LegalSection title="1. Titular del sitio web">
      <p>
        En cumplimiento de la Ley 34/2002, de Servicios de la Sociedad de la
        Información y de Comercio Electrónico (LSSI-CE), se informa de los datos
        del titular de este sitio web:
      </p>
      <ul className="list-disc pl-5 space-y-2">
        <li>
          Denominación social: <strong>CROC LAB, SOCIEDAD LIMITADA</strong>
        </li>
        <li>NIF: B88810940</li>
        <li>Marca comercial: CROC LAB</li>
        <li>
          Domicilio social: C/ Suïssa 10, 2º B, 46006 Valencia, España
        </li>
        <li>
          Establecimiento comercial CROC LAB: C/ del Dr. Romagosa 10, Ciutat
          Vella, 46002 Valencia, España
        </li>
        <li>
          Actividad: servicios de comidas y bebidas, en concreto servicio de
          comida para llevar (CNAE 56.12 – Puestos de comidas)
        </li>
        <li>
          Datos registrales: Registro Mercantil de Valencia, Sección 8, Hoja
          V-235887, Inscripción 1, año 2026 · IRUS: 1000475769483
        </li>
        <li>Administrador único: Maura Bianchi</li>
        <li>
          Constitución e inicio de operaciones: 26 de mayo de 2026 · Capital
          social: 3.000 €
        </li>
        <li>
          Email de contacto:{" "}
          <a
            href="mailto:croclab.valencia@gmail.com"
            className="text-brand-pink font-semibold hover:underline"
          >
            croclab.valencia@gmail.com
          </a>
        </li>
      </ul>
    </LegalSection>
    <LegalSection title="2. Objeto y aceptación">
      <p>
        Este sitio web tiene por objeto presentar la marca CROC LAB, su
        producto, su establecimiento y sus canales de contacto. El acceso y uso
        del sitio implica la aceptación de este Aviso Legal, de la Política de
        Privacidad y de la Política de Cookies.
      </p>
    </LegalSection>
    <LegalSection title="3. Propiedad intelectual e industrial">
      <p>
        El logotipo, la mascota, las fotografías, los textos y el diseño de este
        sitio son titularidad de CROC LAB, SOCIEDAD LIMITADA y no pueden
        reproducirse, distribuirse ni utilizarse con fines comerciales sin
        autorización expresa.
      </p>
    </LegalSection>
    <LegalSection title="4. Enlaces a terceros">
      <p>
        Este sitio incluye enlaces a servicios de terceros (Instagram, TikTok,
        Facebook y Google Maps). CROC LAB no se responsabiliza de los contenidos
        ni de las políticas de privacidad de dichos servicios.
      </p>
    </LegalSection>
    <LegalSection title="5. Responsabilidad">
      <p>
        La información publicada sobre productos, alérgenos, apertura y
        disponibilidad es orientativa y puede actualizarse antes de la apertura
        del establecimiento. CROC LAB no garantiza la ausencia de errores ni la
        disponibilidad continua del sitio.
      </p>
    </LegalSection>
    <LegalSection title="6. Legislación aplicable y jurisdicción">
      <p>
        Este Aviso Legal se rige por la legislación española. Para cualquier
        controversia serán competentes los juzgados y tribunales de Valencia,
        salvo que la normativa de consumidores y usuarios disponga otra cosa.
      </p>
    </LegalSection>
  </LegalLayout>
);

export default AvisoLegal;
